import { PAGE_STATUS_CHANGED, PAGE_ASSETS_LOADING } from 'app/actions/types';

export const pageStatusChanged = (pageStatus) => ({
  type: PAGE_STATUS_CHANGED,
  status: pageStatus,
});

export const pageAssetsLoading = (loadingStatus) => ({
  type: PAGE_ASSETS_LOADING,
  loading: loadingStatus,
});
